import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  static targets = ['checkbox'];

  selectedServices = [];

  checkboxTargetConnected(target) {
    this.toggleServices(target);
  }

  disconnect() {
    this.selectedServices = [];
  }

  updateServices(event) {
    this.toggleServices(event.target);
  }

  // Private

  // A service linked to more than one invoice renders one checkbox per invoice, so a row is keyed by
  // its checkbox id (unique per invoice) rather than by the service id it submits.
  toggleServices({ checked, value, id: key, dataset }) {
    const index = this.selectedServices.findIndex((service) => service.key === key);

    if (checked) {
      if (index !== -1) return;

      const serviceObject = { key, id: value, charge: Number(dataset.charge) };
      this.selectedServices.push(serviceObject);
      this.dispatch('select', { detail: serviceObject, bubbles: true });
      this.dispatchChangeEvent();
      return;
    }

    if (index === -1) return;

    const [service] = this.selectedServices.splice(index, 1);

    this.dispatch('deselect', { detail: service, bubbles: true });
    this.dispatchChangeEvent();
  }

  dispatchChangeEvent() {
    this.dispatch('change', { detail: { selectedServices: this.selectedServices }, bubbles: true });
  }
}
